function wrapColumn(roadItemList, shouldNoWrapFn) {
  const resultGraph = [];
  let tempColumn = [];
  for (let i = 0; i < roadItemList.length; i++) {
      if (tempColumn.length === 0) {
          tempColumn.push(roadItemList[i]);
      }
      else if (shouldNoWrapFn(tempColumn[tempColumn.length - 1], roadItemList[i])) {
          tempColumn.push(roadItemList[i]);
      }
      else {
          resultGraph.push(tempColumn);
          tempColumn = [];
          tempColumn.push(roadItemList[i]);
      }
  }
  resultGraph.push(tempColumn);
  return resultGraph;
}
function truncateColumn(roadItemGraph, columnCount) {
  roadItemGraph.forEach(row => {
      if (columnCount < row.length) {
          row.splice(0, row.length - columnCount);
      }
      else {
          row.push(...Array(columnCount - row.length).fill(undefined));
      }
  });
}
function wrapRow(roadItemGraph, rowCount, columnCount) {
  const resultGraph = Array(rowCount)
      .fill(undefined)
      .map(() => []);
  let count = 0;
  let countTie = 0;
  let currentRowIndex = 0;
  let currentColumnIndex = 0;
  let isTurn = false;
  let temp = false;
  for (let c = 0; c < roadItemGraph.length; c++) {
      if (isTurn && currentRowIndex === 0) {
          temp = true;
      }
      if (temp && currentRowIndex === 0) {
          count = currentColumnIndex + 1;
      }
      else if (temp) {
          count = currentColumnIndex - countTie + 1;
      }
      else {
          count = c;
      }
      isTurn = false;
      countTie = 0;
      for (let r = 0; r < roadItemGraph[c].length; r++) {
          if (roadItemGraph[c][r] !== undefined) {
              if (r < rowCount) {
                  if (!resultGraph[r][count] && !isTurn) {
                      resultGraph[r][count] = roadItemGraph[c][r];
                      currentRowIndex = r;
                      currentColumnIndex = count;
                  }
                  else {
                      resultGraph[currentRowIndex][++currentColumnIndex] =
                          roadItemGraph[c][r];
                      isTurn = true;
                      countTie++;
                  }
              }
              else {
                  isTurn = true;
                  resultGraph[currentRowIndex][++currentColumnIndex] =
                      roadItemGraph[c][r];
                  countTie++;
              }
          }
          else {
              break;
          }
      }
  }
  const maxColCount = Math.max(0, // In case no row exists
  ...resultGraph.map(row => row.length));
  resultGraph.forEach(row => {
      while (row.length < maxColCount) {
          row.push(undefined);
      }
  });
  truncateColumn(resultGraph, columnCount);
  return resultGraph;
}

export {wrapColumn, truncateColumn, wrapRow}
